import { Box, Collapse, Stack } from '@mui/material'
import { TypographySize } from 'components/cattles/checkupPage/processes/typography'
import { cloneElement, forwardRef, ReactElement, useState } from 'react'
import { CardStandart } from 'ui/CardStandart'
import { TypographyHeader } from 'ui/typography/TypographyHeader'
import { TypographyHeaderSecondary } from 'ui/typography/TypographyHeaderSecondary'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'
import { ReactComponent as Arrow } from '../../assets/arrow_open_logo.svg'

interface IExpandableCard {
	title?: string
	titleContent?: ReactElement
	isDefaultOpen?: boolean
	hideToggle?: boolean
	children: ReactElement
	titleSize?: TypographySize
}

const ExpandableCard = forwardRef<HTMLDivElement, IExpandableCard>(
	(props, ref) => {
		const {
			title,
			isDefaultOpen = true,
			hideToggle = false,
			titleSize = 'large',
			children,
			titleContent,
		} = props
		const [isOpen, setIsOpen] = useState<boolean>(isDefaultOpen)
		const isExpanded = hideToggle || isOpen

		const typographyMap = {
			[TypographySize.SMALL]: TypographyPrimary,
			[TypographySize.MEDIUM]: TypographyHeaderSecondary,
			[TypographySize.LARGE]: TypographyHeader,
		}
		const TypographyComponent = typographyMap[titleSize]

		return (
			<CardStandart sx={{ padding: '24px' }} ref={ref}>
				<Stack
					sx={{ cursor: hideToggle ? 'default' : 'pointer' }}
					direction={'row'}
					justifyContent={'space-between'}
					alignItems={'center'}
					onClick={hideToggle ? undefined : () => setIsOpen(prev => !prev)}
					gap={'24px'}
				>
					{titleContent ? (
						titleContent
					) : (
						<TypographyComponent>{title}</TypographyComponent>
					)}

					{!hideToggle && (
						<Box>
							<Arrow
								style={{
									transform: isOpen ? 'rotate(0deg)' : 'rotate(180deg)',
								}}
							/>
						</Box>
					)}
				</Stack>
				<Collapse in={isExpanded} timeout='auto' unmountOnExit={true}>
					{cloneElement(children, { isOpen: isExpanded })}
				</Collapse>
			</CardStandart>
		)
	},
)

export default ExpandableCard

ExpandableCard.displayName = 'ExpandableCard'
